export default __webpack_public_path__ + "static/imac-0f37c084e09b173591480be928cfc05e.png";